export default "/images/998574edd04d403356250f61883da7f6.png";